import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/context/CartContext";

const NAV = [
  { to: "/kauppa/", label: "Kauppa" },
  { to: "/#suodatus", label: "Näin suodatin toimii" },
  { to: "/tietoja-meista/", label: "Tietoja meistä" },
  { to: "/ukk/", label: "UKK" },
  { to: "/yhteystiedot/", label: "Yhteystiedot" },
];

export default function Header() {
  const { count } = useCart();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkClass = ({ isActive }) =>
    `text-sm font-semibold tracking-wide transition-colors duration-200 hover:text-primary ${
      isActive ? "text-primary" : "text-foreground/70"
    }`;

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 glass border-b border-white/40"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between">
          <Link
            to="/"
            data-testid="header-logo"
            className="font-heading text-2xl md:text-3xl font-bold tracking-tight text-water-deep"
            onClick={() => setOpen(false)}
          >
            JINSU
          </Link>

          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end
                className={linkClass}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/ostoskori/"
              data-testid="cart-button"
              className="relative inline-flex h-11 w-11 items-center justify-center rounded-full bg-primary text-primary-foreground transition-transform duration-200 hover:scale-105"
              aria-label="Ostoskori"
            >
              <ShoppingBag size={19} strokeWidth={2.2} />
              {count > 0 && (
                <span
                  data-testid="cart-count"
                  className="absolute -top-1 -right-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-white px-1 text-[11px] font-extrabold text-primary shadow-sm"
                >
                  {count}
                </span>
              )}
            </Link>
            <button
              data-testid="mobile-menu-button"
              className="md:hidden inline-flex h-11 w-11 items-center justify-center rounded-full text-foreground"
              onClick={() => setOpen(!open)}
              aria-label="Valikko"
              aria-expanded={open}
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav
          data-testid="mobile-nav"
          className="md:hidden glass border-t border-white/40 px-6 py-6 flex flex-col gap-5"
        >
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end
              onClick={() => setOpen(false)}
              className={linkClass}
              data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
